export type Category = 'night-suits' | 't-shirts'

export type Fit = 'women' | 'men'

export interface Product {
  id: string
  name: string
  category: Category
  price: number
  colour: string
  colourHex: string
  composition: string
  detail: string
  images: Record<Fit, string>
  sizes: Record<Fit, string[]>
}

export interface CartLine {
  product: Product
  size: string
  fit: Fit
  quantity: number
}

export const fitLabels: Record<Fit, string> = {
  women: 'Women',
  men: 'Men',
}
